<template>
    <rect x="0.5" y="0.5" width="65" height="65" rx="10" fill="url(#paint0_linear_1951_107)" />
    <rect width="20.8124" height="22.2915" rx="2" transform="matrix(0.866025 0.5 -2.92729e-08 1 15.6445 14.7227)" fill="#353CEE" />
    <rect
        x="-0.866025"
        y="-0.5"
        width="29.8427"
        height="24.1845"
        rx="3"
        transform="matrix(0.866025 -0.5 3.68496e-08 1 25.3683 28.2076)"
        fill="#FAFCFF"
        stroke="#072046"
        stroke-width="2"
    />
    <defs>
        <linearGradient id="paint0_linear_1951_107" x1="33" y1="0.5" x2="33" y2="65.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#0B2957" />
            <stop offset="0.953125" stop-color="#031837" />
        </linearGradient>
    </defs>
</template>
